import { Box, Typography } from '@mui/material';
import { UserAvatar } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';

const RequesterDetails = ({ data }) => {
  const { t } = useTranslation('orders');

  return (
    <Box
      flexGrow={1}
      display="flex"
      flexDirection="column"
      gap={1}
      p={{ xs: 2, md: 0 }}
      ml={{ xs: 0, md: 2 }}
    >
      <Typography variant="subtitle2">
        {t('tableHeaders.orderedBy')}:
      </Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <UserAvatar
          photo={data.requester?.photo}
          firstName={data.requester.firstName}
          lastName={data.requester.lastName}
        />
        <Typography variant="body2">
          {[data.requester.firstName, data.requester.lastName]
            .filter(x => x)
            .join(' ')}
        </Typography>
      </Box>
    </Box>
  );
};

export default RequesterDetails;
